import {
  action,
  createTransformer,
  observable,
  useStrict
} from 'mobx';

import {
  observer
} from 'mobx-react';

import AppState from '../AppState';
import { layout } from '../../theme';

useStrict();

const transformItem = createTransformer((item) => ({
  ...item,
  bounds: {
    height: 0,
    width: 0,
    left: 0,
    top: 0,
  },
  zoomed: false,
}));

const transformList = createTransformer((list) => ({
  ...list,
  items: list.items.map(transformItem),
}));

const transformLists = createTransformer((lists) => lists.map(transformList));

const ListsState = {
  lists: transformLists(AppState.data.sections.topTen.lists),

  get activeItem() {
    let activeItem = null;
    this.lists.forEach(list => {
      list.items.forEach(item => {
        if (item.zoomed) activeItem = item;
      });
    });
    return activeItem;
  },

  updateBounds: action(function(listIndex, itemIndex, bounds) {
    const list = this.lists[listIndex];
    const item = list ? list.items[itemIndex] : null;
    if (item) item.bounds = bounds;
  }),

  toggleZoom: action(function(listIndex, itemIndex) {
    const list = this.lists[listIndex];
    const item = list && itemIndex !== undefined ? list.items[itemIndex] : null;
    const zoomed = item ? !item.zoomed : false;

    this.lists.forEach(list => {
      list.items.forEach((i, ii) => {
        i.zoomed = false;
      });
    });

    if (item) item.zoomed = zoomed;

  }),
};

export default observer(observable(ListsState));



// WEBPACK FOOTER //
// ./src/states/ListsState/index.js